import React from 'react';
import ProgressLoader from './ProgressLoader';

interface LoaderProps {
  progress: number;
  titleText?: string;
}

const Loader: React.FC<LoaderProps> = ({ progress, titleText }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-opacity-50 bg-gray-900">
      <div className="flex flex-col items-center bg-white p-8 rounded-lg shadow-lg">
        {titleText && (
          <p className="text-primaryBlack text-sm pb-8 pt-4 font-bold">
            {titleText}
          </p>
        )}
        <div className="relative  w-80  bg-gray-200 rounded-full overflow-hidden">
          <ProgressLoader progress={progress} height="100%" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
